export default __webpack_public_path__ + "static/media/sounds/TRO_Test_Mic_Try_Again.mp3";